import React from 'react'

import FormManager from "../../common/form-manager"
import FormModel from "../../common/form-model-manager"

// @ts-ignore
import ColorSelector from '../../../gd-components/color/selector/selector'

type Props = {
    className?  : string

    form        : FormManager | FormModel
    name        : string

    disabled?   : boolean
}

export default class ColorPickerFormElement extends React.Component<Props> {

    componentDidMount() {
        this.props.form.registerFormComponent(this.props.name,this)
    }

    onChange = (newValue: string) => {
        this.props.form.onFormComponentValueChange(this.props.name, newValue)
    }

    render() {
        const value = this.props.form.getValue(this.props.name);

        return (
            <ColorSelector className    = {this.props.className}
                           type         = "default-26"
                           value        = {parseInt(value)}
                           disabled     = {this.props.disabled}
                           onChange     = {this.onChange} />
        )
    }
}
